import { styled } from '@mui/material/styles';
import { PopupButton } from '../../../styles/buttonStyles';

export const ButtonStyled = styled(PopupButton)(({
    width: "100px"
}));